import gif from './bowl-animated.gif';

export default [gif];
